// import webshop from '@wwdev/webshop';
import shipping from '@wwdev/webshop/shipping'
import Checkout from "@solundo/webshop/js/Checkout";
import Bindings from "@wwdev/webshop/bindings";
// import Variants from "@wwdev/webshop/variants";
import Popup from '@wwdev/webshop/v2/popup';
import Login from '@wwdev/winkelwagen/v2/login';
import "@wwdev/winkelwagen/form";
import "./product"

shipping.init();

new Popup();
new Login();

(new Checkout()).init();
Bindings.init();
// Variants.init();
